var map = {
	"./1-_DSC9412.jpg": 88,
	"./2-_DSC0706.jpg": 89,
	"./3-_DSC0900.jpg": 90,
	"./4-_DSC1112.jpg": 91,
	"./5-_DSC6871.jpg": 92,
	"./6-_DSC6893.jpg": 93,
	"./7-_DSC7439.jpg": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29;